import * as React from 'react';
import Select from '../select';
export default class MiniSelect extends React.Component {
    // size="small"
    render() {
        return <Select {...this.props}/>;
    }
}
MiniSelect.Option = Select.Option;
